const ADPUSH = "adpush";
const CSS_TOP_BANNER = ADPUSH + "-top-banner";
const CSS_TOP_BANNER_TRANSITION_SLIDEDOWN = CSS_TOP_BANNER + "-transition-slidedown";
const CSS_TOP_BANNER_TRANSITION_SLIDEUP = CSS_TOP_BANNER + "-transition-slideup";
const CSS_TOP_BANNER_BUTTON = CSS_TOP_BANNER + "-button";
const CSS_TOP_BANNER_CLOSE = CSS_TOP_BANNER + "-close";
const CSS_TOP_BANNER_CONTENT = CSS_TOP_BANNER + "-content";
const CSS_HIDDEN = ADPUSH + "-hidden";
const CSS_REGISTRATION_PAGE_ELEMENT = ADPUSH + "-open-registration-page";
const LS_NOTIFICATION = ADPUSH + "-notification";
const LS_USER = ADPUSH + "-user";
const COOKIE_USER_ID = ADPUSH + "-userId";
const COOKIE_USER_FP = ADPUSH + "-userFP";

export const constants = {
    ADPUSH,
    CSS_TOP_BANNER,
    CSS_TOP_BANNER_TRANSITION_SLIDEDOWN,
    CSS_TOP_BANNER_TRANSITION_SLIDEUP,
    CSS_TOP_BANNER_BUTTON,
    CSS_TOP_BANNER_CLOSE,
    CSS_TOP_BANNER_CONTENT,
    CSS_HIDDEN,
    CSS_REGISTRATION_PAGE_ELEMENT,
    LS_NOTIFICATION,
    LS_USER,
    COOKIE_USER_ID,
    COOKIE_USER_FP
    };